import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspCheckinReportsService {

  constructor(private http: HttpClient) { }

    checkInDetails(garageKey,userKey,bookingId,jobCard){
      let param={
        garageKey:garageKey,
        userKey:userKey,
        bookingId: bookingId,
        jobCardId:jobCard
       
      }
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/booking/v1/checkInReport`,param)
    }
    acceptReject(bookingId,jobCardId,garageKey,jobCardStatus){
      let param={
        bookingId: bookingId,
        jobCardId: jobCardId,
        garageKey: garageKey,
        jobCardStatus: jobCardStatus,
       
      }
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/booking/v1/jobCardStatus/update`,param)
    }
    // Inside asp-checkin-reports.service.ts or a new whatsapp-message.service.ts

sendWhatsAppMessage(templateName: string, messagePayload: any) {
  const url = `${GlobalVariable.BASE_API_URL_AUTOVERSE_SPARES}/messaging/api/v1/send-wa-sms`;

  // Set query params
  let params = new HttpParams()
    .set('accountId', '1')
    .set('eventName', templateName)
    .set('messageType', 'WhatsApp');

  // Set form-urlencoded headers
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'skip-api-key': 'skip'
  });


  // Make POST request
  return this.http.post(url, messagePayload, { headers, params });
}


}